<template>
  <b-form-group
    label="Fax"
    label-for="fax"
  >
    <b-input-group>
      <b-input-group-prepend is-text>
        TR (+90)
      </b-input-group-prepend>
      <cleave
        id="fax"
        v-model="dataItem.fax"
        class="form-control"
        :raw="true"
        :options="options.fax"
        placeholder="Fax"
      />
    </b-input-group>
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.tr'

export default {
  name: 'Fax',
  components: {
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    Cleave,
  },
  data() {
    return {
      options: {
        fax: {
          phone: true,
          phoneRegionCode: 'TR',
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['configCompany/dataItem']
    },
  },
}
</script>
